// extracted by mini-css-extract-plugin
module.exports = {"container":"Radio_container__3U8V3","text":"Radio_text__3dZHx"};